import { Grid, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';

import { updateFallThree } from 'apis/survey';
import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';
import MuiDialog from 'components/MuiDialog';
import {
  TFallThreeDefaultValues,
  SurveyDialogProps,
} from 'routes/Main/Survey/type';

import CommonPatientInfo from '../components/CommonPatientInfo';
import FallThreeContents from './FallThreeContents';
import EducationList from './EducationList';

const FallThree = (props: SurveyDialogProps<TFallThreeDefaultValues>) => {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    user_id,
    patientInfo,
    nurseName,
    onClose,
  } = props;

  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();

  const { handleSubmit, watch, register, getValues, setValue } = useForm({
    defaultValues,
  });

  const onSubmit = (data: TFallThreeDefaultValues) => {
    const { patient_id } = patientInfo;
    const {
      assessment,
      age,
      fall,
      evacuation,
      drug,
      device,
      mobility00,
      mobility01,
      mobility02,
      recognition00,
      recognition01,
      recognition02,
    } = data;

    const request = {
      user_id,
      patient_id: patientInfo.patient_id,
      fall3_survey: {
        assessment: JSON.stringify(assessment),
        age,
        fall,
        evacuation,
        drug,
        device,
        mobility00: JSON.stringify(mobility00),
        mobility01: JSON.stringify(mobility01),
        mobility02: JSON.stringify(mobility02),
        recognition00: JSON.stringify(recognition00),
        recognition01: JSON.stringify(recognition01),
        recognition02: JSON.stringify(recognition02),
      },
    };

    updateFallThree(request)
      .then(({ data: { rc } }) => {
        if (rc !== 1) return onResultCode(rc);
        onUpdateIsSave(true);
        onSuccess('저장되었습니다');
      })
      .catch(e => onFail('저장에 실패하였습니다', e));
  };

  const formProps = {
    disabled,
    watch,
    register,
    getValues,
    setValue,
    onRequired,
  };

  return (
    <MuiDialog.SurveyForm
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Grid
        container
        wrap="wrap"
        rowSpacing={5}
        columnSpacing={3}
        sx={{ py: 5, px: 1 }}
      >
        <Typography
          sx={{
            margin: '40px auto 0px auto',
            fontWeight: '700',
            fontSize: '16px',
            textAlign: 'center',
          }}
        >
          낙상위험 평가도구 3
        </Typography>
        <CommonPatientInfo patientInfo={patientInfo} nurseName={nurseName} />
        <EducationList {...formProps} />
        <FallThreeContents {...formProps} />
      </Grid>
    </MuiDialog.SurveyForm>
  );
};

export default FallThree;
